<template>
  <!-- Modal Archivo-->
  <div
    class="modal fade"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    id="modalPdf"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content modal-embajadores">
        <div class="modal-header modal-archivo__encabezado">
          <h5 class="modal-title modal-embajadores__titulo">
            Revisión de documento
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <iframe
            class="modal-embajadores__iframe"
            :src="urlDocumento"
          ></iframe>
        </div>
        <div class="modal-footer modal-embajadores__pie">
          <button
            type="button"
            class="btn modal-embajadores__boton modal-embajadores__boton-primario"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalPdf",
  props: {
    urlDocumento: String,
    titulo: String
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/estilos/estilosgenerales.scss";
</style>
